import { differenceInHours } from "date-fns";

/**
 * Returns true if the given date/time is at least 12 hours from the provided currentDate.
 * Assumes the input is always a valid Date object.
 */
export function isAtLeast12HoursAway(date: Date, currentDate: Date): boolean {
  const hoursUntil = differenceInHours(date, currentDate);
  return hoursUntil >= 12;
}
